export default "__VITE_ASSET__PrqmP724__"